export class ApaSizeMatrixdto {
    id?: number;
    buyMonth?: string;
    fdOf?: string;
    styleNumber?: string;
    styleType?: string;
    usaSize?: string;
    chinaSizeMatrixtype?: string;
    chinaTopSize?: string;
    chinaTopBodysize?: string;
    chinaBottomSize?: string;
    chinaBottomBodysize?: string;
    koreaSizeMatrixtype?: string;
    koreaTopGeneric?: string;
    koreaTopChest?: string;
    koreaTopHeight?: string;
    koreaBottomGeneric?: string;
    koreaBottomWaist?: string;
    koreaBottomHip?: string;
    koreaAge?: string;
    ftyShk?: string;

    createdUser?: string;
    isActive?:boolean;
    updatedUser?:string;
    versionFlag?: number;
    constructor(id?: number, buyMonth?:string, fdOf?: string,  styleNumber?: string,
        styleType?: string,usaSize?: string,  chinaSizeMatrixtype?: string,
        chinaTopSize?: string,chinaTopBodysize?: string,  chinaBottomSize?: string,
        chinaBottomBodysize?: string,koreaSizeMatrixtype?: string, koreaTopGeneric?: string,
        koreaTopChest?: string,  koreaTopHeight?: string,  koreaBottomGeneric?: string,
        koreaBottomWaist?: string,  koreaBottomHip?: string, koreaAge?: string,  ftyShk?: string,
        createdUser?:string,isActive?:boolean,versionFlag?: number,    updatedUser?:string
        ) {
      this.id = id;
      this.buyMonth = buyMonth
      this .fdOf = fdOf
      this .styleNumber = styleNumber
      this .styleType = styleType
      this .usaSize = usaSize
      this .chinaSizeMatrixtype = chinaSizeMatrixtype
      this .chinaTopSize = chinaTopSize
      this .chinaTopBodysize = chinaTopBodysize
      this .chinaBottomSize = chinaBottomSize
      this .chinaBottomBodysize = chinaBottomBodysize
      this .koreaSizeMatrixtype = koreaSizeMatrixtype
      this .koreaTopGeneric = koreaTopGeneric
      this .koreaTopChest = koreaTopChest
      this .koreaTopHeight = koreaTopHeight
      this .koreaBottomGeneric = koreaBottomGeneric
      this .koreaBottomWaist = koreaBottomWaist
      this .koreaBottomHip = koreaBottomHip
      this .koreaAge = koreaAge
      this .ftyShk = ftyShk
      

      this.createdUser = createdUser;
      this.isActive = isActive;
      this.versionFlag = versionFlag;
      this.updatedUser = updatedUser
    }
  }
  